import LazyLoad from "react-lazyload"
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"
const FeildTrip = () => {
    const homeMenu = [
        {
            label: "Curriculum", link: "", subMenu: [
                { label: "Primary Wing", link: "/primarywing" },
                { label: "Middle Wing", link: "/middleWing" },
                { label: "Senior Wing", link: "/seniorWing" },
                { label: "Curriculum", link: "/curriculum" },
            ]
        },

        {
            label: "Extended Classroom", link: "", subMenu: [
                { label: "Labs", link: "/mathmatics" },
                { label: "Excursions", link: "/excursions" },
                { label: "Library", link: "/library" },
                { label: "Field Trips", link: "/feildTrip" },
                { label: "Astronomy", link: "/astronomy" },
            ]
        },
        {
            label: "Sports", link: "", subMenu: [
                { label: "Sports", link: "/sports" },
                { label: "Achievements in Sports 2022-23", link: "/acheivementInSports" },
            ]
        },
        {
            label: "Arts", link: "", subMenu: [
                { label: "Performing Arts", link: "/music" },
                { label: "Visual Arts", link: "/visualArts" }
            ]
        },

        { label: "Houses", link: "/houses" },
        { label: "Assembly", link: "/assembly" },
        { label: "Book List", link: "/booklist" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/field-trip.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Field Trips" breadEnd="Learning Approach" breadMid="Field Trips" />
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-xl-12 mb-4"> 
                            <p>Field trips and visits play a pivotal role in Child’s learning. It gives the students an opportunity to learn through observation and helps them experience a more holistic and integrated picture of information beyond textual knowledge. Student Learning needs to be interest driven and not teacher or Curriculum driven.</p>
                           <LazyLoad> <img src="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/field-trip1.jpg" className="float-end wid-500 m-2" alt="Lotus Valley Gurgaon" /></LazyLoad>
                            <p>Our School plans age and theme appropriate visits for all Grades from Pre Nursery – III. To inculcate the value of Secularism and respect for all religions , every year our Pre Nursery and Nursery Learners visit the Church and the Gurudwara. These visits aid in providing an educational as well as spiritual experience to the little ones. Visits to Transport Museum, Sanskriti Museum , Kidzzania and Pottery factory for higher grades connect to the lessons and our young minds are therefore able to use their knowledge in class through real life exposure.</p>
                            <p>These Trips deepen and enhance classroom study. A shared social experience provides the opportunity for students to encounter and explore novel things in an authentic setting . “Learning Beyond Classrooms’ is the School ethos and we are able to achieve the desired goals through the medium of Field trips, camps and visits.</p>
                            <p>The school also organizes Day Camps for the young learners. The aim of Education is the Wholesome Development of these young minds.These camps bring forth, the leadership skills of learners and builds the initiative to take risks and overcome fears. Unplugged from Technology, the camp helps them to enhance their abilities, encourage teamwork, self-confidence and self-esteem, gain resilience and develop camaraderie.</p>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default FeildTrip